// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {version} from "../package.json"
const appVersion = version

import {createApp} from 'vue'
import router from './router';

import {IonicVue} from '@ionic/vue';

/* Core CSS required for Ionic components to work properly */
import '@ionic/vue/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/vue/css/normalize.css';
import '@ionic/vue/css/structure.css';
import '@ionic/vue/css/typography.css';

/* Theme variables */
import './theme/variables.css';

import './assets/tailwind.css';
import vue3PhotoPreview from 'vue3-photo-preview';
import 'vue3-photo-preview/dist/index.css';
import 'floating-vue/dist/style.css';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import VueVirtualScroller from 'vue-virtual-scroller';
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css';

import 'plyr/dist/plyr.css';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import VirtualList from 'vue-virtual-list-v3';

import './registerServiceWorker';
import {ObserveVisibility} from 'vue3-observe-visibility'
import App from './App.vue'

const app = createApp(App)

app
    .use(IonicVue)
    .use(router)
    .use(vue3PhotoPreview)
    .use(VueVirtualScroller)
    .use(VirtualList)

app.directive('observe-visibility', ObserveVisibility)

app.provide('appVersion', appVersion)

try {
    app.mount('#app');
} catch (e) {
    console.error('App mount failed', e)
}

router.isReady().catch((e) => console.error('Router failed', e));
